import React, { useEffect } from "react";
import useGetData from "../../../hooks/useGetData";
import { useState } from "react";
import PosDropdownSection from "../Pos/PosDropdownSection";
import SalesListTableSection from "../SalesList/SalesListTableSection";
import SortSection from "../../../components/DashboardComponents/SortSection";
import InputLoadingTwo from "../../../components/Loading/InputLoadingTwo";
import { FaCalendarAlt } from "react-icons/fa";

const SalesPaymentInformationTableSection = () => {
  const salesTable = [
    {
      id: 10,
      name: "SL",
    },
    {
      id: 11,
      name: "Payment Date",
    },
    {
      id: 12,
      name: "Payment Code",
    },
    {
      id: 13,
      name: "Sales Code",
    },
    {
      id: 14,
      name: "Customer Name",
    },
    {
      id: 15,
      name: "Customer Id",
    },
    {
      id: 16,
      name: "Payment",
    },
    {
      id: 17,
      name: "Account Name",
    },
    {
      id: 18,
      name: "Payment Type",
    },
    {
      id: 19,
      name: "Payment Status",
    },
  ];

  const paymentStatusData = [
    {
      id: 1,
      name: "All Payment Status",
    },
    {
      id: 2,
      name: "Paid",
    },
    {
      id: 3,
      name: "Partially Paid",
    },
    {
      id: 4,
      name: "Due",
    },
  ];

  // get  salesPaymentList Data from backend
  const [salesPaymentListData, refetch, isLoading] = useGetData(
    `/sales/sales-payments`,
    "salesListData"
  );

  // get data from backend
  const [paymentTypeData, refetchPayment, isLoadingPayment] = useGetData(
    "/paymenttype/viewpaymenttypes/",
    "paymenttypeData"
  );
  const [updatedPaymentTypeData, setUpdatedPaymentTypeData] = useState([]);
  // Define the custom customer data
  const customPaymentTypeData = {
    id: null,
    payment_type: "All Payment Type",
    status: null,
  };
  useEffect(() => {
    if (paymentTypeData) {
      setUpdatedPaymentTypeData([customPaymentTypeData, ...paymentTypeData]);
    }
  }, [paymentTypeData]);

  const [data, setData] = useState([]);
  const [paymentStatusDropdownValue, setPaymentStatusDropdownValue] =
    useState("Select-Status");
  const [paymentTypeDropdownValue, setPaymentTypeTwoDropdownValue] = useState(
    "Select-Payment-Type"
  );
  const [searchValue, setSearchValue] = useState("");
  const [selectedValue, setSelectedValue] = useState(10);
  const [formDateValue, setFormDateValue] = useState("");
  const [toDateValue, setToDateValue] = useState("");

  // apply filters on jobs
  const applyFilters = () => {
    if (salesPaymentListData) {
      let filteredArray = [...salesPaymentListData];
      // Apply payment Type filter
      if (
        paymentTypeDropdownValue !== "Select-Payment-Type" &&
        paymentTypeDropdownValue !== "All Payment Type"
      ) {
        filteredArray = filteredArray.filter(
          (item) =>
            item?.payment_type?.toLowerCase() ===
            paymentTypeDropdownValue?.toLowerCase()
        );
      }

      // Apply payments status filter
      if (
        paymentStatusDropdownValue !== "All Payment Status" &&
        paymentStatusDropdownValue !== "Select-Status"
      ) {
        filteredArray = filteredArray.filter(
          (item) =>
            item?.payment_status?.toLowerCase() ===
            paymentStatusDropdownValue?.toLowerCase()
        );
      }

      // Apply date range filter
      if (formDateValue || toDateValue) {
        filteredArray = filteredArray.filter((item) => {
          const itemDate = new Date(item?.payment_date);
          return (
            itemDate >= new Date(formDateValue) ||
            itemDate <= new Date(toDateValue)
          );
        });
      }

      // Apply search filter
      if (searchValue.trim() !== "") {
        filteredArray = filteredArray.filter((item) =>
          item?.customer_name
            ?.toLowerCase()
            .includes(searchValue?.toLowerCase())
        );
      }
      setData(filteredArray);
    }
  };

  useEffect(() => {
    applyFilters();
  }, [
    paymentTypeDropdownValue,
    paymentStatusDropdownValue,
    salesPaymentListData,
    searchValue,
    paymentTypeData,
    toDateValue,
    formDateValue,
  ]);

  return (
    <>
      {/* section-1 */}
      {!paymentTypeData && isLoadingPayment ? (
        <>
          <InputLoadingTwo numSections={2} />
        </>
      ) : (
        <>
          <section className="d-flex justify-content-between align-items-center p-4">
            <div style={{ width: "48%" }}>
              <h5 className="text-start ">Payment Type</h5>
              <div
                style={{ width: "100%" }}
                className=" d-flex justify-content-between align-items-center border border rounded-1 "
                title="Warehouse"
              >
                {/* dropdown data */}
                {paymentTypeData && (
                  <PosDropdownSection
                    inputType={"search"}
                    InitialDropdownValue={"Select-Payment-Type"}
                    data={updatedPaymentTypeData || []}
                    titleData={"Payment Type"}
                    placeHolderData={"Enter Payment Type"}
                    setPaymentTypeTwoDropdownValue={
                      setPaymentTypeTwoDropdownValue
                    }
                  ></PosDropdownSection>
                )}
              </div>
            </div>
            <div style={{ width: "48%" }}>
              <h5 className="text-start ">Payment Status</h5>
              <div
                style={{ width: "100%" }}
                className="  d-flex justify-content-between align-items-center border rounded-1"
                title="Customer"
              >
                {paymentTypeData && paymentStatusData && (
                  <PosDropdownSection
                    inputType={"search"}
                    InitialDropdownValue={"Select-Status"}
                    data={paymentStatusData || []}
                    titleData={"Select Status"}
                    placeHolderData={"Enter Payment Status"}
                    setPaymentStatusDropdownValue={
                      setPaymentStatusDropdownValue
                    }
                  ></PosDropdownSection>
                )}
              </div>
            </div>
          </section>
          <section className="d-flex justify-content-between align-items-center px-4 ">
            <div style={{ width: "48%" }}>
              <h5 className="text-start ">From Date</h5>
              <div
                style={{ width: "100%" }}
                className="d-flex border justify-content-between rounded-1 align-items-center"
              >
                <span className="border-end  p-2">
                  <FaCalendarAlt />
                </span>
                <div className="w-100 px-1 position-relative">
                  <input
                    type="date"
                    className="w-100 border-0"
                    name="fromDateInput"
                    onChange={(e) => {
                      setFormDateValue(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div style={{ width: "48%" }}>
              <h5 className="text-start ">To Date</h5>
              <div
                style={{ width: "100%" }}
                className="d-flex border justify-content-between rounded-1 align-items-center"
              >
                <span className="border-end  p-2">
                  <FaCalendarAlt />
                </span>
                <div className="w-100 px-1 position-relative">
                  <input
                    type="date"
                    className="w-100 border-0"
                    name="toDateInput"
                    onChange={(e) => {
                      setToDateValue(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
          </section>
        </>
      )}

      {/* section-2 */}
      <section className="my-4 px-4">
        <div className="row">
          <SortSection
            setSelectedValue={setSelectedValue}
            setSearchValue={setSearchValue}
            searchValue={searchValue}
          ></SortSection>
        </div>
      </section>
      {/* section-3 */}
      <section
        className="mx-4 p-2 border rounded-2 bg-body-secondary "
        style={{ height: "55vh", overflowY: "scroll", overflowX: "hidden" }}
      >
        <SalesListTableSection
          tableHeader={salesTable}
          showTable={"salesPaymentList"}
          isLoading={isLoading || isLoadingPayment}
          tableData={
            selectedValue !== "allData" ? data?.slice(0, selectedValue) : data
          }
        ></SalesListTableSection>
      </section>
    </>
  );
};

export default SalesPaymentInformationTableSection;
